// extracted by mini-css-extract-plugin
export default {"wrapper":"WrapperComponent_wrapper__lPBZi"};